import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Comparative Performance',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Total ($MM)',
                  values: {
                    if: [
                      [
                        {
                          not: {
                            '=': [
                              {
                                '@$': 'piRecordId',
                              },
                              null,
                            ],
                          },
                        },
                        {
                          '[]': [
                            {
                              '{}': {
                                name: {
                                  '@': 'piName',
                                },
                                points: {
                                  '[]': [
                                    {
                                      '{}': {
                                        x: '2024',
                                        y: {
                                          '+': {
                                            '->': [
                                              {
                                                '@': '2024_Pis',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'selectedPiProjectsExpenses',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      },
                                    },
                                    {
                                      '{}': {
                                        x: '2025',
                                        y: {
                                          '+': {
                                            '->': [
                                              {
                                                '@': '2025_Pis',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'selectedPiProjectsExpenses',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                            {
                              '{}': {
                                name: 'Average across all PIs',
                                points: {
                                  '[]': [
                                    {
                                      '{}': {
                                        x: '2024',
                                        y: {
                                          '/': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2024_Pis',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'projectsExpenses',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '#': {
                                                '@': '2024_Pis',
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    },
                                    {
                                      '{}': {
                                        x: '2025',
                                        y: {
                                          '/': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2025_Pis',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'projectsExpenses',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '#': {
                                                '@': '2025_Pis',
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                          ],
                        },
                      ],
                      [
                        {
                          and: [
                            {
                              not: {
                                '=': [
                                  {
                                    '@$': 'orgRecordId',
                                  },
                                  null,
                                ],
                              },
                            },
                            {
                              not: {
                                '=': [
                                  {
                                    '@$': 'orgEntityId',
                                  },
                                  null,
                                ],
                              },
                            },
                          ],
                        },
                        {
                          '[]': [
                            {
                              '{}': {
                                name: {
                                  '@': 'orgName',
                                },
                                points: {
                                  '[]': [
                                    {
                                      '{}': {
                                        x: '2024',
                                        y: {
                                          '+': {
                                            '->': [
                                              {
                                                '@': '2024_orgs',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'selectedOrgProjectsExpenses',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      },
                                    },
                                    {
                                      '{}': {
                                        x: '2025',
                                        y: {
                                          '+': {
                                            '->': [
                                              {
                                                '@': '2025_orgs',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'selectedOrgProjectsExpenses',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                            {
                              '{}': {
                                name: 'Average across all Organizations',
                                points: {
                                  '[]': [
                                    {
                                      '{}': {
                                        x: '2024',
                                        y: {
                                          '/': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2024_orgs',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'projectsExpenses',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '#': {
                                                '@': '2024_orgs',
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    },
                                    {
                                      '{}': {
                                        x: '2025',
                                        y: {
                                          '/': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2025_orgs',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'projectsExpenses',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '#': {
                                                '@': '2025_orgs',
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                          ],
                        },
                      ],
                      {
                        '[]': [
                          {
                            '{}': {
                              name: '',
                              points: {
                                '[]': [
                                  {
                                    '{}': {
                                      x: '2024',
                                      y: {
                                        '+': {
                                          '->': [
                                            {
                                              '@': '2024_projectsGlExpenses',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                {
                                                  if: [
                                                    [
                                                      {
                                                        '=': [
                                                          {
                                                            '@$': 'financialVolume',
                                                          },
                                                          'MTDC',
                                                        ],
                                                      },
                                                      'mtdcAmount',
                                                    ],
                                                    'tdcAmount',
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                    },
                                  },
                                  {
                                    '{}': {
                                      x: '2025',
                                      y: {
                                        '+': {
                                          '->': [
                                            {
                                              '@': '2025_projectsGlExpenses',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                {
                                                  if: [
                                                    [
                                                      {
                                                        '=': [
                                                          {
                                                            '@$': 'financialVolume',
                                                          },
                                                          'MTDC',
                                                        ],
                                                      },
                                                      'mtdcAmount',
                                                    ],
                                                    'tdcAmount',
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        ],
                      },
                    ],
                  },
                },
              },
              {
                '{}': {
                  name: 'Total Density (MM/ASF)',
                  values: {
                    if: [
                      [
                        {
                          not: {
                            '=': [
                              {
                                '@$': 'piRecordId',
                              },
                              null,
                            ],
                          },
                        },
                        null,
                      ],
                      [
                        {
                          and: [
                            {
                              not: {
                                '=': [
                                  {
                                    '@$': 'orgRecordId',
                                  },
                                  null,
                                ],
                              },
                            },
                            {
                              not: {
                                '=': [
                                  {
                                    '@$': 'orgEntityId',
                                  },
                                  null,
                                ],
                              },
                            },
                          ],
                        },
                        {
                          '[]': [
                            {
                              '{}': {
                                name: {
                                  '@': 'orgName',
                                },
                                points: {
                                  '[]': [
                                    {
                                      '{}': {
                                        x: '2024',
                                        y: {
                                          '+': {
                                            '->': [
                                              {
                                                '@': '2024_orgs',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'selectedOrgDensity',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      },
                                    },
                                    {
                                      '{}': {
                                        x: '2025',
                                        y: {
                                          '+': {
                                            '->': [
                                              {
                                                '@': '2025_orgs',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'selectedOrgDensity',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                            {
                              '{}': {
                                name: 'Average across all Organizations',
                                points: {
                                  '[]': [
                                    {
                                      '{}': {
                                        x: '2024',
                                        y: {
                                          '/': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2024_orgs',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'density',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2024_orgs',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'useForComputeAvgDensity',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    },
                                    {
                                      '{}': {
                                        x: '2025',
                                        y: {
                                          '/': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2025_orgs',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'density',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2025_orgs',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'useForComputeAvgDensity',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                          ],
                        },
                      ],
                      {
                        '[]': [
                          {
                            '{}': {
                              name: '',
                              points: {
                                '[]': [
                                  {
                                    '{}': {
                                      x: '2024',
                                      y: {
                                        '/': [
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': '2024_projectsGlExpenses',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    {
                                                      if: [
                                                        [
                                                          {
                                                            '=': [
                                                              {
                                                                '@$': 'financialVolume',
                                                              },
                                                              'MTDC',
                                                            ],
                                                          },
                                                          'mtdcAmount',
                                                        ],
                                                        'tdcAmount',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': '2024_rooms',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'asf',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  },
                                  {
                                    '{}': {
                                      x: '2025',
                                      y: {
                                        '/': [
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': '2025_projectsGlExpenses',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    {
                                                      if: [
                                                        [
                                                          {
                                                            '=': [
                                                              {
                                                                '@$': 'financialVolume',
                                                              },
                                                              'MTDC',
                                                            ],
                                                          },
                                                          'mtdcAmount',
                                                        ],
                                                        'tdcAmount',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': '2025_rooms',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'asf',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        ],
                      },
                    ],
                  },
                },
              },
              {
                '{}': {
                  name: 'Utilization (%)',
                  values: {
                    if: [
                      [
                        {
                          not: {
                            '=': [
                              {
                                '@$': 'piRecordId',
                              },
                              null,
                            ],
                          },
                        },
                        null,
                      ],
                      [
                        {
                          and: [
                            {
                              not: {
                                '=': [
                                  {
                                    '@$': 'orgRecordId',
                                  },
                                  null,
                                ],
                              },
                            },
                            {
                              not: {
                                '=': [
                                  {
                                    '@$': 'orgEntityId',
                                  },
                                  null,
                                ],
                              },
                            },
                          ],
                        },
                        {
                          '[]': [
                            {
                              '{}': {
                                name: {
                                  '@': 'orgName',
                                },
                                points: {
                                  '[]': [
                                    {
                                      '{}': {
                                        x: '2024',
                                        y: {
                                          '*': [
                                            100,
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2024_orgs',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'selectedOrgUtilization',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    },
                                    {
                                      '{}': {
                                        x: '2025',
                                        y: {
                                          '*': [
                                            100,
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2025_orgs',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'selectedOrgUtilization',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                            {
                              '{}': {
                                name: 'Average across all Organizations',
                                points: {
                                  '[]': [
                                    {
                                      '{}': {
                                        x: '2024',
                                        y: {
                                          '*': [
                                            100,
                                            {
                                              '/': [
                                                {
                                                  '+': {
                                                    '->': [
                                                      {
                                                        '@': '2024_orgs',
                                                      },
                                                      {
                                                        '@>': [
                                                          {
                                                            '@$': '$value',
                                                          },
                                                          'utilization',
                                                        ],
                                                      },
                                                    ],
                                                  },
                                                },
                                                {
                                                  '+': {
                                                    '->': [
                                                      {
                                                        '@': '2024_orgs',
                                                      },
                                                      {
                                                        '@>': [
                                                          {
                                                            '@$': '$value',
                                                          },
                                                          'useForComputeAvgUtilization',
                                                        ],
                                                      },
                                                    ],
                                                  },
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                    },
                                    {
                                      '{}': {
                                        x: '2025',
                                        y: {
                                          '*': [
                                            100,
                                            {
                                              '/': [
                                                {
                                                  '+': {
                                                    '->': [
                                                      {
                                                        '@': '2025_orgs',
                                                      },
                                                      {
                                                        '@>': [
                                                          {
                                                            '@$': '$value',
                                                          },
                                                          'utilization',
                                                        ],
                                                      },
                                                    ],
                                                  },
                                                },
                                                {
                                                  '+': {
                                                    '->': [
                                                      {
                                                        '@': '2025_orgs',
                                                      },
                                                      {
                                                        '@>': [
                                                          {
                                                            '@$': '$value',
                                                          },
                                                          'useForComputeAvgUtilization',
                                                        ],
                                                      },
                                                    ],
                                                  },
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                          ],
                        },
                      ],
                      {
                        '[]': [
                          {
                            '{}': {
                              name: '',
                              points: {
                                '[]': [
                                  {
                                    '{}': {
                                      x: '2024',
                                      y: {
                                        '*': [
                                          100,
                                          {
                                            '/': [
                                              {
                                                '+': {
                                                  '->': [
                                                    {
                                                      '@': '2024_rooms',
                                                    },
                                                    {
                                                      '@>': [
                                                        {
                                                          '@$': '$value',
                                                        },
                                                        'asf',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                '+': {
                                                  '->': [
                                                    {
                                                      '@': '2024_rooms',
                                                    },
                                                    {
                                                      '@>': [
                                                        {
                                                          '@$': '$value',
                                                        },
                                                        'sqft',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  },
                                  {
                                    '{}': {
                                      x: '2025',
                                      y: {
                                        '*': [
                                          100,
                                          {
                                            '/': [
                                              {
                                                '+': {
                                                  '->': [
                                                    {
                                                      '@': '2025_rooms',
                                                    },
                                                    {
                                                      '@>': [
                                                        {
                                                          '@$': '$value',
                                                        },
                                                        'asf',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                '+': {
                                                  '->': [
                                                    {
                                                      '@': '2025_rooms',
                                                    },
                                                    {
                                                      '@>': [
                                                        {
                                                          '@$': '$value',
                                                        },
                                                        'sqft',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        ],
                      },
                    ],
                  },
                },
              },
            ],
          },
          type: 'bar',
        },
      },
    },
  },
  subqueries: {
    piName: {
      filter: {
        and: [
          {
            '@$': 'piRecordId',
          },
          {
            '=': [
              {
                '@.': '!id',
              },
              {
                '@$': 'piRecordId',
              },
            ],
          },
        ],
      },
      target: 'ent:!personnel:!employee',
      selection: {
        '@.': '!name',
      },
    },
    orgName: {
      filter: {
        and: [
          {
            '@$': 'orgRecordId',
          },
          {
            '@$': 'orgEntityId',
          },
          {
            '=': [
              {
                '@.': '!id',
              },
              {
                '@$': 'orgRecordId',
              },
            ],
          },
          {
            '=': [
              {
                '@_': 'id',
              },
              {
                '@$': 'orgEntityId',
              },
            ],
          },
        ],
      },
      target: 'dim::!org',
      selection: {
        '@.': '!name',
      },
    },
    '2024_Pis': {
      filter: {
        '@$': 'piRecordId',
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2024',
          },
          start: {
            $date: '01/01/2024',
          },
        },
      },
      target: 'ent:!personnel:!employee',
      selection: {
        '{}': {
          name: {
            '@.': '!name',
          },
          tdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          isSelected: {
            if: [
              [
                {
                  '=': [
                    {
                      '@.': '!id',
                    },
                    {
                      '@$': 'piRecordId',
                    },
                  ],
                },
                1,
              ],
              0,
            ],
          },
          mtdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          projectsExpenses: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'financialVolume',
                    },
                    'MTDC',
                  ],
                },
                {
                  '@>': 'mtdcAmount',
                },
              ],
              {
                '@>': 'tdcAmount',
              },
            ],
          },
          selectedPiProjectsExpenses: {
            '*': [
              {
                '@>': 'projectsExpenses',
              },
              {
                '@>': 'isSelected',
              },
            ],
          },
        },
      },
      subqueries: {
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!proj',
          },
          using: 'piProjectAssignments',
          filter: {
            and: [
              {
                not: {
                  '=': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    null,
                  ],
                },
              },
            ],
          },
          target: 'ent:!projects:!proj',
          selection: {
            '{}': {
              tdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              },
              mtdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
            },
          },
          subqueries: {
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  idcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'IDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  tdcAmount: {
                    if: [
                      [
                        {
                          not: {
                            '=': [
                              {
                                '@': 'costType',
                              },
                              'IDC',
                            ],
                          },
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'MTDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                costType: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!cost_type',
                  },
                },
              },
            },
          },
        },
        piProjectAssignments: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!pi',
          },
          target: 'ent:!proj_pis:!entry',
        },
      },
    },
    '2025_Pis': {
      filter: {
        '@$': 'piRecordId',
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2025',
          },
          start: {
            $date: '01/01/2025',
          },
        },
      },
      target: 'ent:!personnel:!employee',
      selection: {
        '{}': {
          name: {
            '@.': '!name',
          },
          tdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          isSelected: {
            if: [
              [
                {
                  '=': [
                    {
                      '@.': '!id',
                    },
                    {
                      '@$': 'piRecordId',
                    },
                  ],
                },
                1,
              ],
              0,
            ],
          },
          mtdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          projectsExpenses: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'financialVolume',
                    },
                    'MTDC',
                  ],
                },
                {
                  '@>': 'mtdcAmount',
                },
              ],
              {
                '@>': 'tdcAmount',
              },
            ],
          },
          selectedPiProjectsExpenses: {
            '*': [
              {
                '@>': 'projectsExpenses',
              },
              {
                '@>': 'isSelected',
              },
            ],
          },
        },
      },
      subqueries: {
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!proj',
          },
          using: 'piProjectAssignments',
          filter: {
            and: [
              {
                not: {
                  '=': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    null,
                  ],
                },
              },
            ],
          },
          target: 'ent:!projects:!proj',
          selection: {
            '{}': {
              tdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              },
              mtdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
            },
          },
          subqueries: {
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  idcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'IDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  tdcAmount: {
                    if: [
                      [
                        {
                          not: {
                            '=': [
                              {
                                '@': 'costType',
                              },
                              'IDC',
                            ],
                          },
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'MTDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                costType: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!cost_type',
                  },
                },
              },
            },
          },
        },
        piProjectAssignments: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!pi',
          },
          target: 'ent:!proj_pis:!entry',
        },
      },
    },
    '2024_orgs': {
      filter: {
        and: [
          {
            '@$': 'orgEntityId',
          },
          {
            '@$': 'orgRecordId',
          },
          {
            '=': [
              {
                '@_': 'id',
              },
              {
                '@$': 'orgEntityId',
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2024',
          },
          start: {
            $date: '01/01/2024',
          },
        },
      },
      target: 'dim::!org',
      selection: {
        '{}': {
          id: {
            '@.': '!id',
          },
          density: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'projectsExpenses',
                  },
                  {
                    '@>': 'totalAsf',
                  },
                ],
              },
            ],
          },
          totalAsf: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'rooms',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'asf',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          tdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          totalSqft: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'rooms',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'sqft',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          isSelected: {
            if: [
              [
                {
                  '=': [
                    {
                      '@.': '!id',
                    },
                    {
                      '@$': 'orgRecordId',
                    },
                  ],
                },
                1,
              ],
              0,
            ],
          },
          mtdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          utilization: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalSqft',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'totalAsf',
                  },
                  {
                    '@>': 'totalSqft',
                  },
                ],
              },
            ],
          },
          projectsExpenses: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'financialVolume',
                    },
                    'MTDC',
                  ],
                },
                {
                  '@>': 'mtdcAmount',
                },
              ],
              {
                '@>': 'tdcAmount',
              },
            ],
          },
          selectedOrgDensity: {
            '*': [
              {
                '@>': 'density',
              },
              {
                '@>': 'isSelected',
              },
            ],
          },
          selectedOrgUtilization: {
            '*': [
              {
                '@>': 'utilization',
              },
              {
                '@>': 'isSelected',
              },
            ],
          },
          useForComputeAvgDensity: {
            if: [
              [
                {
                  '!=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                1,
              ],
              0,
            ],
          },
          selectedOrgProjectsExpenses: {
            '*': [
              {
                '@>': 'projectsExpenses',
              },
              {
                '@>': 'isSelected',
              },
            ],
          },
          useForComputeAvgUtilization: {
            if: [
              [
                {
                  '!=': [
                    {
                      '@>': 'totalSqft',
                    },
                    0,
                  ],
                },
                1,
              ],
              0,
            ],
          },
        },
      },
      subqueries: {
        rooms: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!space',
          },
          using: 'orgSpaceAssignments',
          filter: {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceType',
                  },
                  null,
                ],
              },
              {
                in: [
                  {
                    '@.': [
                      '!space_use',
                      {
                        ref: {
                          entity: '!group',
                        },
                      },
                    ],
                  },
                  {
                    '@>': [
                      {
                        '@$': 'spaceType',
                      },
                      'ent:!space_use:!group',
                    ],
                  },
                ],
              },
            ],
          },
          target: 'ent:!space:!room',
          selection: {
            '{}': {
              asf: {
                '*': [
                  {
                    '@.': '!sqft',
                  },
                  {
                    '/': [
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '*': [
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'allowable',
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      },
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'value',
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                ],
              },
              sqft: {
                '@.': '!sqft',
              },
            },
          },
          subqueries: {
            weights: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!space',
                inherit: '-',
              },
              filter: {
                '!=': [
                  {
                    '@.': '!weight',
                  },
                  0,
                ],
              },
              target: 'ent:!space_funcl:!entry',
              selection: {
                '{}': {
                  value: {
                    '@.': '!weight',
                  },
                  allowable: {
                    if: [
                      [
                        {
                          '!=': [
                            {
                              '@': 'funcIdCat',
                            },
                            null,
                          ],
                        },
                        1,
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                funcIdCat: {
                  ref: {
                    attr: 'attr:ent#!space_funcl#!entry:!func_space',
                  },
                  target: 'ent:!func_space:!func',
                  selection: {
                    '@.': [
                      '!func_idc',
                      {
                        ref: {
                          entity: '!cat',
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!org',
            inherit: '-',
          },
          filter: {
            and: [
              {
                not: {
                  '=': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    null,
                  ],
                },
              },
            ],
          },
          target: 'ent:!projects:!proj',
          selection: {
            '{}': {
              tdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              },
              mtdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
            },
          },
          subqueries: {
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  idcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'IDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  tdcAmount: {
                    if: [
                      [
                        {
                          not: {
                            '=': [
                              {
                                '@': 'costType',
                              },
                              'IDC',
                            ],
                          },
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'MTDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                costType: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!cost_type',
                  },
                },
              },
            },
          },
        },
        orgSpaceAssignments: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!org',
            inherit: '-',
          },
          target: 'ent:!org_space:!entry',
        },
      },
    },
    '2025_orgs': {
      filter: {
        and: [
          {
            '@$': 'orgEntityId',
          },
          {
            '@$': 'orgRecordId',
          },
          {
            '=': [
              {
                '@_': 'id',
              },
              {
                '@$': 'orgEntityId',
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2025',
          },
          start: {
            $date: '01/01/2025',
          },
        },
      },
      target: 'dim::!org',
      selection: {
        '{}': {
          id: {
            '@.': '!id',
          },
          density: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'projectsExpenses',
                  },
                  {
                    '@>': 'totalAsf',
                  },
                ],
              },
            ],
          },
          totalAsf: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'rooms',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'asf',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          tdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          totalSqft: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'rooms',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'sqft',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          isSelected: {
            if: [
              [
                {
                  '=': [
                    {
                      '@.': '!id',
                    },
                    {
                      '@$': 'orgRecordId',
                    },
                  ],
                },
                1,
              ],
              0,
            ],
          },
          mtdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          utilization: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalSqft',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'totalAsf',
                  },
                  {
                    '@>': 'totalSqft',
                  },
                ],
              },
            ],
          },
          projectsExpenses: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'financialVolume',
                    },
                    'MTDC',
                  ],
                },
                {
                  '@>': 'mtdcAmount',
                },
              ],
              {
                '@>': 'tdcAmount',
              },
            ],
          },
          selectedOrgDensity: {
            '*': [
              {
                '@>': 'density',
              },
              {
                '@>': 'isSelected',
              },
            ],
          },
          selectedOrgUtilization: {
            '*': [
              {
                '@>': 'utilization',
              },
              {
                '@>': 'isSelected',
              },
            ],
          },
          useForComputeAvgDensity: {
            if: [
              [
                {
                  '!=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                1,
              ],
              0,
            ],
          },
          selectedOrgProjectsExpenses: {
            '*': [
              {
                '@>': 'projectsExpenses',
              },
              {
                '@>': 'isSelected',
              },
            ],
          },
          useForComputeAvgUtilization: {
            if: [
              [
                {
                  '!=': [
                    {
                      '@>': 'totalSqft',
                    },
                    0,
                  ],
                },
                1,
              ],
              0,
            ],
          },
        },
      },
      subqueries: {
        rooms: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!space',
          },
          using: 'orgSpaceAssignments',
          filter: {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceType',
                  },
                  null,
                ],
              },
              {
                in: [
                  {
                    '@.': [
                      '!space_use',
                      {
                        ref: {
                          entity: '!group',
                        },
                      },
                    ],
                  },
                  {
                    '@>': [
                      {
                        '@$': 'spaceType',
                      },
                      'ent:!space_use:!group',
                    ],
                  },
                ],
              },
            ],
          },
          target: 'ent:!space:!room',
          selection: {
            '{}': {
              asf: {
                '*': [
                  {
                    '@.': '!sqft',
                  },
                  {
                    '/': [
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '*': [
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'allowable',
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      },
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'value',
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                ],
              },
              sqft: {
                '@.': '!sqft',
              },
            },
          },
          subqueries: {
            weights: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!space',
                inherit: '-',
              },
              filter: {
                '!=': [
                  {
                    '@.': '!weight',
                  },
                  0,
                ],
              },
              target: 'ent:!space_funcl:!entry',
              selection: {
                '{}': {
                  value: {
                    '@.': '!weight',
                  },
                  allowable: {
                    if: [
                      [
                        {
                          '!=': [
                            {
                              '@': 'funcIdCat',
                            },
                            null,
                          ],
                        },
                        1,
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                funcIdCat: {
                  ref: {
                    attr: 'attr:ent#!space_funcl#!entry:!func_space',
                  },
                  target: 'ent:!func_space:!func',
                  selection: {
                    '@.': [
                      '!func_idc',
                      {
                        ref: {
                          entity: '!cat',
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!org',
            inherit: '-',
          },
          filter: {
            and: [
              {
                not: {
                  '=': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    null,
                  ],
                },
              },
            ],
          },
          target: 'ent:!projects:!proj',
          selection: {
            '{}': {
              tdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              },
              mtdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
            },
          },
          subqueries: {
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  idcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'IDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  tdcAmount: {
                    if: [
                      [
                        {
                          not: {
                            '=': [
                              {
                                '@': 'costType',
                              },
                              'IDC',
                            ],
                          },
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@': 'costType',
                            },
                            'MTDC',
                          ],
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                costType: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!cost_type',
                  },
                },
              },
            },
          },
        },
        orgSpaceAssignments: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!org',
            inherit: '-',
          },
          target: 'ent:!org_space:!entry',
        },
      },
    },
    '2024_rooms': {
      filter: {
        and: [
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              null,
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgEntityId',
                  },
                  null,
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceType',
                  },
                  null,
                ],
              },
              {
                in: [
                  {
                    '@.': [
                      '!space_use',
                      {
                        ref: {
                          entity: '!group',
                        },
                      },
                    ],
                  },
                  {
                    '@>': [
                      {
                        '@$': 'spaceType',
                      },
                      'ent:!space_use:!group',
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2024',
          },
          start: {
            $date: '01/01/2024',
          },
        },
      },
      target: 'ent:!space:!room',
      selection: {
        '{}': {
          asf: {
            '*': [
              {
                '@.': '!sqft',
              },
              {
                '/': [
                  {
                    '+': {
                      '->': [
                        {
                          '@': 'weights',
                        },
                        {
                          '*': [
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'value',
                              ],
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'allowable',
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  },
                  {
                    '+': {
                      '->': [
                        {
                          '@': 'weights',
                        },
                        {
                          '@>': [
                            {
                              '@$': '$value',
                            },
                            'value',
                          ],
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
          sqft: {
            '@.': '!sqft',
          },
        },
      },
      subqueries: {
        weights: {
          ref: {
            attr: 'attr:ent#!space_funcl#!entry:!space',
            inherit: '-',
          },
          filter: {
            '!=': [
              {
                '@.': '!weight',
              },
              0,
            ],
          },
          target: 'ent:!space_funcl:!entry',
          selection: {
            '{}': {
              value: {
                '@.': '!weight',
              },
              allowable: {
                if: [
                  [
                    {
                      '!=': [
                        {
                          '@': 'funcIdCat',
                        },
                        null,
                      ],
                    },
                    1,
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            funcIdCat: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!func_space',
              },
              target: 'ent:!func_space:!func',
              selection: {
                '@.': [
                  '!func_idc',
                  {
                    ref: {
                      entity: '!cat',
                    },
                  },
                ],
              },
            },
          },
        },
        roomOrgs: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!space',
          },
          target: 'ent:!org_space:!entry',
        },
      },
    },
    '2025_rooms': {
      filter: {
        and: [
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              null,
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgEntityId',
                  },
                  null,
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceType',
                  },
                  null,
                ],
              },
              {
                in: [
                  {
                    '@.': [
                      '!space_use',
                      {
                        ref: {
                          entity: '!group',
                        },
                      },
                    ],
                  },
                  {
                    '@>': [
                      {
                        '@$': 'spaceType',
                      },
                      'ent:!space_use:!group',
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2025',
          },
          start: {
            $date: '01/01/2025',
          },
        },
      },
      target: 'ent:!space:!room',
      selection: {
        '{}': {
          asf: {
            '*': [
              {
                '@.': '!sqft',
              },
              {
                '/': [
                  {
                    '+': {
                      '->': [
                        {
                          '@': 'weights',
                        },
                        {
                          '*': [
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'value',
                              ],
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'allowable',
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  },
                  {
                    '+': {
                      '->': [
                        {
                          '@': 'weights',
                        },
                        {
                          '@>': [
                            {
                              '@$': '$value',
                            },
                            'value',
                          ],
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
          sqft: {
            '@.': '!sqft',
          },
        },
      },
      subqueries: {
        weights: {
          ref: {
            attr: 'attr:ent#!space_funcl#!entry:!space',
            inherit: '-',
          },
          filter: {
            '!=': [
              {
                '@.': '!weight',
              },
              0,
            ],
          },
          target: 'ent:!space_funcl:!entry',
          selection: {
            '{}': {
              value: {
                '@.': '!weight',
              },
              allowable: {
                if: [
                  [
                    {
                      '!=': [
                        {
                          '@': 'funcIdCat',
                        },
                        null,
                      ],
                    },
                    1,
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            funcIdCat: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!func_space',
              },
              target: 'ent:!func_space:!func',
              selection: {
                '@.': [
                  '!func_idc',
                  {
                    ref: {
                      entity: '!cat',
                    },
                  },
                ],
              },
            },
          },
        },
        roomOrgs: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!space',
          },
          target: 'ent:!org_space:!entry',
        },
      },
    },
    '2024_projectsGlExpenses': {
      filter: {
        and: [
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              null,
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgEntityId',
                  },
                  null,
                ],
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2024',
          },
          start: {
            $date: '1/1/2024',
          },
        },
      },
      target: 'ent:!projects:!proj',
      selection: {
        '{}': {
          tdcAmount: {
            '+': {
              '->': [
                {
                  '@': 'glExpenses',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    'tdcAmount',
                  ],
                },
              ],
            },
          },
          mtdcAmount: {
            '+': {
              '->': [
                {
                  '@': 'glExpenses',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    'mtdcAmount',
                  ],
                },
              ],
            },
          },
        },
      },
      subqueries: {
        glExpenses: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '{}': {
              idcAmount: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@': 'costType',
                        },
                        'IDC',
                      ],
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
              tdcAmount: {
                if: [
                  [
                    {
                      not: {
                        '=': [
                          {
                            '@': 'costType',
                          },
                          'IDC',
                        ],
                      },
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
              mtdcAmount: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@': 'costType',
                        },
                        'MTDC',
                      ],
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            costType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!cost_type',
              },
            },
          },
        },
      },
    },
    '2025_projectsGlExpenses': {
      filter: {
        and: [
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              null,
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgEntityId',
                  },
                  null,
                ],
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2025',
          },
          start: {
            $date: '1/1/2025',
          },
        },
      },
      target: 'ent:!projects:!proj',
      selection: {
        '{}': {
          tdcAmount: {
            '+': {
              '->': [
                {
                  '@': 'glExpenses',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    'tdcAmount',
                  ],
                },
              ],
            },
          },
          mtdcAmount: {
            '+': {
              '->': [
                {
                  '@': 'glExpenses',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    'mtdcAmount',
                  ],
                },
              ],
            },
          },
        },
      },
      subqueries: {
        glExpenses: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '{}': {
              idcAmount: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@': 'costType',
                        },
                        'IDC',
                      ],
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
              tdcAmount: {
                if: [
                  [
                    {
                      not: {
                        '=': [
                          {
                            '@': 'costType',
                          },
                          'IDC',
                        ],
                      },
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
              mtdcAmount: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@': 'costType',
                        },
                        'MTDC',
                      ],
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            costType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!cost_type',
              },
            },
          },
        },
      },
    },
  },
}
